import { create } from 'zustand';
import { defaultMessageCentreThreadData } from '../Data/MessageCentreThreadData';
import { MessageCentreThreadStoreType } from '../../Types/MessageCentreThreadStoreTypes';
import MessageCentreThreadReducer from '../Reducers/MessageCentreThreadReducers';

const useMessageCentreThreadStore = create<MessageCentreThreadStoreType>((set) => ({
	...defaultMessageCentreThreadData,
	dispatchMessageCentreThreadStoreUpdate: (action) => set((state) => MessageCentreThreadReducer(state, action)),
}));

export { useMessageCentreThreadStore };
